<template> 
  <div v-loading.fullscreen.lock="loading" :element-loading-text="text"></div> 
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EdLoading',
  data() {
    return {
      loading:false,
      text:null,
    };
  },
  mounted(){
    this.$utilidade.console('::EdLoading module loaded::')
  },  
  methods: {
    set(loading,text){
      this.loading = loading
      this.text = text
    },
  },
  computed: {
  },
  watch: {
    loading(){
    },
    text(){
    }
  },
}
</script>


// WEBPACK FOOTER //
// EdLoading.vue?5d7a6d94